import React, { createContext, useContext, useEffect, useState } from "react";
import { addToWishlist, getWishlist, removeFromWishlist } from "../utils/wishlistDB";

const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
  const [wishlist, setWishlist] = useState([]);

  useEffect(() => {
    getWishlist().then(setWishlist).catch(console.error);
  }, []);

  const toggle = async (item) => {
    const exists = wishlist.some((w) => w.id === item.id);
    if (exists) {
      await removeFromWishlist(item.id);
      setWishlist((prev) => prev.filter((w) => w.id !== item.id));
    } else {
      await addToWishlist(item);
      setWishlist((prev) => [...prev, item]);
    }
  };

  const isWishlisted = (id) => wishlist.some((w) => w.id === id);

  return (
    <WishlistContext.Provider value={{ wishlist, toggle, isWishlisted }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
